module.exports = __webpack_public_path__ + "img/Autumn-text.0ccc354e.jpg";